import { JoiningProgress } from "@vivagym-joining/joining-progress";

document.addEventListener("DOMContentLoaded", async () => {
	let country = VgHelpers.getCountry();

	window.notificationsActive = true;

	const formStep = document.getElementById("vg-login-form");
	const name = document.getElementById("name");
	const email = document.getElementById("email");
	const password = document.getElementById("password");
	const acceptConditions = document.getElementById("conditions");
	const btnGuest = document.getElementById("btn-login-guest");
	const btnUser = document.getElementById("btn-login-user");

	let withPassword = false;
	let userType = "";
	let userCountry = country;
	let changeCountry = false;

	const constraints = getConstraints();

	JoiningProgress.onDataReady(initStep);

	const vgForms = new VGForms();

	function initStep(progress) {
		console.log("Loaded progress data:", progress);

		vgForms.fieldsLiveValidation(constraints);

		formStep.addEventListener("submit", (event) => {
			event.preventDefault();
			let data = { leadType: "new" };
			console.log("Event: initJoining", data);
			redirectFormStep(data);
		});

		btnUser.addEventListener("click", (event) => {
			event.preventDefault();
			const newsletter = document.querySelector(
				"input[name='newsletter']"
			)?.checked;
			let data = {
				user: {
					type: userType,
					country: country,
					data: {
						name: name.value,
						email: email.value,
						newsletter: newsletter,
					},
				},
			};
			console.log("Event: initJoining submit", data);
			if (validateForm()) {
				if (true == withPassword) {
					const api = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());
					api.action = "login_user_data";
					api.params = {
						email: email.value,
						password: password.value,
					};

					api.handleRequest().then( async (data) => {
						if (data) {
							console.log("Login user data:", data); // TODO: debug purposes, delete after testing
							if (null == data.error) {
								data = {
									user: {
										type: userType,
										country: data.personData.person.address.country.toLowerCase(),
										personData: data.personData,
										token: data.token,
										data: {
											name: name.value,
											email: email.value,
										},
									},
								};

								// If the user is logged in, save the token for the case Lead with password.
								// TODO: Consider use the data event instead of progress and manage the token in the controller.
								await progress.load();
								progress.setUserToken(data.user.token);
								await progress.save();

								redirectFormStep(data);
							} else {
								removeMessagePass();
								addMessagePass(data.error);
							}
						} else {
							console.error("Failed to fetch data.");
						}
					});
				} else {
					if (changeCountry) {
						data.user.country = changeCountry;
					}
					redirectFormStep(data);
				}
			}
		});

		btnGuest.addEventListener("click", (event) => {
			event.preventDefault();
			btnGuest.disabled = true;
			userType = "Guest";
			let data = {
				user: {
					type: userType,
					country: userCountry,
					data: {
						name: null,
						email: null,
						country: country,
						newsletter: null,
					},
				},
			};
			console.log("Event: initJoining", data);
			redirectFormStep(data);
		});

		name.addEventListener("keyup", (event) => {
			validateName();
			checkingErrorForm();
		});

		email.addEventListener("keyup", (event) => {
			validateEmail();
			checkingErrorForm();
		});

		email.addEventListener("change", async (event) => {
			let email = event.target.value;
			if (!email || /\S+@\S+\.\S+/.test(email) == false) {
				return;
			}
			const locale = VgHelpers.getCountry();

			disabledPanelPassword();
			disabledPanelNewsletter();
			password.value = "";

			const apiClient = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());
			const userExists = await apiClient.checkIfExist(email, locale);
			console.log("Check if exists:", userExists);

			if (userExists.error != null) {
				const errorMessage = JoiningVars.get_form_field('user-data').email_invalid;
				vgForms.showErrorElement(document.querySelector("input[name='email']"), errorMessage);
				console.error("Error in AJAX request:", userExists.error);
				return;
			}

			if (userExists.exists) {

				userCountry = userExists.country.toLowerCase();
				userType = userExists.status;

				switch (userExists.status) {
					case "Blacklist":
						showNotificationBlocked();
						break;
					case "Inactive":
						withPassword = true;
						showPanelPassword();
						break;
					case "Suspended":
						withPassword = true;
						showPanelPassword();
						break;
					case "Active":
						withPassword = true;
						showPanelPassword();
						break;
					case "Lead":
						if (userExists.token) {
							// TODO: Consider use the data event instead of progress and manage the token in the controller.
							progress.setUserToken(userExists.token);
							await progress.save();
							withPassword = false;
							changeCountry = userExists.country;
						} else {
							withPassword = true;
							showPanelPassword();
						}
						break;
					default:
						withPassword = false;
				}
			} else {
				userType = "New";
				enablePanelNewsletter();
			}
		});

		password.addEventListener("keyup", (event) => {
			checkingErrorForm();
		});

		acceptConditions.addEventListener("click", (event) => {
			if (true == event.target.checked && validateForm()) {
				enabledButtonUser();
			} else {
				disabledButtonUser();
			}
			checkingErrorForm();
		});
	}

	function checkAcceptConditions(acceptConditions) {
		return acceptConditions.checked;
	}

	function checkingErrorForm() {
		let result = true;
		if (false == validateForm()) {
			formStep
				.querySelectorAll(".vg-form__field-group")
				.forEach((group_field) => {
					if (group_field.classList.contains("has-error")) {
						result = false;
					}
				});
			if (result) {
			}
		}
		console.log("result", result);
	}

	function disabledPanelNewsletter() {
		document.querySelector(
			".field-group-checkbox-newsletter"
		).style.display = "none";
	}

	function enablePanelNewsletter() {
		document.querySelector(
			".field-group-checkbox-newsletter"
		).style.display = "flex";
	}

	function disabledPanelPassword() {
		withPassword = false;
		document.querySelector(".vg-form__panel-password").style.display =
			"none";
	}

	function showPanelPassword() {
		document.querySelector(".vg-form__panel-password").style.display =
			"block";
		checkingErrorForm();
	}

	function validateName() {
		let fieldConstraints = vgForms.getFieldConstraint(
			"name",
			constraints
		);
		removeErrorElement(name);
		vgForms.isValid(name.value,name,fieldConstraints.constraints);
	}

	function validateEmail() {
		let fieldConstraints = vgForms.getFieldConstraint(
			"email",
			constraints
		);
		removeErrorElement(email);
		return vgForms.isValid(email.value,email,fieldConstraints.constraints);
	}

	function validateForm() {
		let result = true;
		disabledButtonUser();

		if (0 == name.value.length) {
			result = false;
		}

		if (!validateEmail()) {
			result = false;
		}

		if (0 == password.value.length && true == withPassword) {
			result = false;
		}

		if (false == acceptConditions.checked) {
			result = false;
		}

		if (result == true) {
			enabledButtonUser();
		}
		return result;
	}

	function removeErrorElement(element) {
		const elementGroup = element.closest(".vg-form__field-group");
		if (elementGroup?.querySelectorAll(".hasClass").length > 0) {
			elementGroup.classList.remove("has-error");
			elementGroup.querySelectorAll(".hasClass").forEach((element) => {
				element.remove();
			});
		}
	}

	function redirectFormStep(data) {
		document.dispatchEvent(
			new CustomEvent("initJoining", { detail: data })
		);
	}

	// TODO: Modals
	function showNotificationBlocked() {
		new VgModal({
			title: JoiningVars.get_form_field("modals").joining_init_blocked.title,
			description: JoiningVars.get_form_field("modals").joining_init_blocked.content,
			data: [],
			type: "error",
			template: "basic",
			status: "Blacklist",
		});
	}

	function disabledButtonUser() {
		btnUser.setAttribute("disabled", "");
	}

	function enabledButtonUser() {
		btnUser.removeAttribute("disabled");
	}

	/** */
	const parentElement = document.querySelector(".vg-form__panel-password");
	const passwordReset = parentElement.querySelector("input");
	const fieldMessage = parentElement.querySelector(".vg-form__field-message");
	const eyePass = parentElement.querySelector(".icon--eye");
	const tooltip = parentElement.querySelector("vg-tooltip");
	eyePass.style.display = "none";

	passwordReset.addEventListener("change", function () {
		removeMessagePass();
		if (passwordReset.value.length == 0) {
			addMessagePass(JoiningVars.get_form_field("user-data").field_required);
			eyePass.style.display = "none";
			tooltip.style.display = "block";
		} else {
			eyePass.style.display = "block";
			tooltip.style.display = "none";
		}
	});
	function addMessagePass(message) {
		if (fieldMessage.querySelector("span") == null) {
			const span = document.createElement("span");
			span.innerHTML = message;
			fieldMessage.prepend(span);
			parentElement.classList.add("has-error");
		}
	}
	function removeMessagePass() {
		if (fieldMessage.querySelector("span") != null) {
			fieldMessage.querySelector("span").remove();
			parentElement.classList.remove("has-error");
		}
	}

	passwordReset.addEventListener("keyup", function () {
		eyePass.style.display = "block";
		tooltip.style.display = "none";
		if (passwordReset.value.length == 0) {
			eyePass.style.display = "none";
			tooltip.style.display = "block";
		}
	});


	function getConstraints() {
		let constraints = [];

		constraints.push(
			{
				field_name: "name",
				type: "input",
				constraints: [
					{
						rule: "min_length",
						params: {
							min_length: 1,
							error_message: JoiningVars.get_form_field("nombre-requerido"),
							stopper: true,
						},
					},
					{
						rule: "regexp",
						params: {
							regexp: /^[A-Za-zÁÉÍÓÚÜÑÀÈÒÂÊÔÃÕÇÄÖÜŸÆŒáéíóúüñàèòâêôãõçäëïöüÿéèêîïùûœæß' -]+$/,
							error_message: JoiningVars.get_form_field("user-data").invalid_chars,
							stopper: true,
						}
					},
				]
			},
		);

		constraints.push(
			{
				field_name: "email",
				type: "input",
				constraints: [
					{
						rule: "min_length",
						params: {
							min_length: 1,
							error_message: JoiningVars.get_form_field("email-requerido"),
							stopper: true,
						},
					},
					{
						rule: "regexp",
						params: {
							regexp: /\S+@\S+\.\S+/,
							error_message: JoiningVars.get_form_field("email-invalido"),
						}
					},
				]
			},
		);

		return constraints
	}

});
